import React from 'react'
import { ExternalOAuthSuccess } from '../components/ExternalOAuthSuccess'

const SignUpCallback = () => {
  const params = new URLSearchParams(window.location.search)
  const email = params.get('email')
  const providerUserId = params.get('providerUserId')
  const providerType = params.get('providerType')
  const firstName = params.get('firstName')
  const lastName = params.get('lastName')
  const source = params.get('source')

  const isExternalSource = source === 'figma'

  if (email && providerUserId && providerType && firstName) {
    const signUpData = {
      email,
      firstName,
      lastName,
      providerUserId,
      providerType,
    }

    localStorage.setItem('signUpData', JSON.stringify(signUpData))

    if (!isExternalSource) {
      window.close()
    }
  }

  if (isExternalSource) {
    return <ExternalOAuthSuccess toolName="Figma" />
  }

  return <div />
}

export default SignUpCallback
